import api from './api';

export interface Category {
  id: string;
  name: string;
  description: string | null;
  icon: string | null;
  createdAt: string;
}

export interface CategoriesListResponse {
  categories: Category[];
  total: number;
}

export const categoryService = {
  /**
   * Get all categories
   */
  async getAllCategories(): Promise<CategoriesListResponse> {
    const response = await api.get('/categories');
    return response.data;
  },

  /**
   * Get single category by ID
   */
  async getCategory(id: string): Promise<Category> {
    const response = await api.get(`/categories/${id}`);
    return response.data;
  },
};

